import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import BookingPage from './pages/BookingPage';
import { Typography, Box } from '@mui/material';
import BookingConfirmationPage from './pages/BookingConfirmationPage';
import LandingPage from './pages/LandingPage';
import SearchPage from './pages/SearchPage';
import Footer from './components/Footer';

function PageWrapper({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </Box>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<PageWrapper><LandingPage /></PageWrapper>} />
      <Route path="/:slug" element={<PageWrapper><BookingPage /></PageWrapper>} />
      <Route path="/confirmation" element={<PageWrapper><BookingConfirmationPage /></PageWrapper>} />
      {/* <Route path="/search" element={<PageWrapper><SearchPage /></PageWrapper>} /> */}
    </Routes>
  );
}
